import PropTypes from "prop-types"
import MetaTags from "react-meta-tags"
import React, { useEffect } from "react"
import {
    Row,
    Col,
    Container,
} from "reactstrap"

//redux
import { useSelector, useDispatch } from "react-redux"

import { withRouter, Link } from "react-router-dom"

// Formik Validation

// action
import { AppConfiguration } from "config"
import { unlockTokenAdminUser } from "store/admin/Authentication/Unlock-Account/actions"

const ForgetPasswordPage = props => {
    const dispatch = useDispatch()
    const urlParams = new URLSearchParams(location.search);

    const unlock_token = urlParams.get('unlock_token')

    // const validation = useFormik({
    //     // enableReinitialize : use this flag when initial values needs to be changed
    //     enableReinitialize: true,

    //     initialValues: {
    //         email: "",
    //     },
    //     validationSchema: Yup.object({
    //         email: Yup.string().email().required("Please Enter Your Email"),
    //     }),
    //     onSubmit: values => {
    //         dispatch(unlockAccountAdminUser(values, props.history))
    //     },
    // })

    const handleUnlock = () => {
        if (unlock_token) {
            dispatch(unlockTokenAdminUser({ unlock_token: unlock_token }, props.history))
        }
    };


    const { loading, error } = useSelector(state => ({
        error: state.UnlockAdminUser.error,
        loading: state.UnlockAdminUser.loading,
    }))

    useEffect(() => {
        if (!unlock_token) {
            props.history.push("/login")
        }
        handleUnlock();
    }, [unlock_token]);

    return (
        <React.Fragment>
            <MetaTags>
                <title>Contact Admin | {AppConfiguration.WEBSITE}</title>
            </MetaTags>
            <div className="account-pages my-5 pt-sm-5">
                <Container>
                    <Row className="justify-content-center">
                        <Col md={8} lg={6} xl={5}>
                            <div className="text-center">
                                <span className="h1">Please Contact Admin</span>
                            </div>
                            <div className="mt-5 text-center">
                                <p>
                                    Go back to{" "}
                                    <Link to="/login" className="font-weight-medium text-sfblue">
                                        Login
                                    </Link>{" "}
                                </p>
                                <p>
                                    © {new Date().getFullYear()} {AppConfiguration.WEBSITE}
                                </p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

ForgetPasswordPage.propTypes = {
    history: PropTypes.object,
}

export default withRouter(ForgetPasswordPage)
